import { Center, Skeleton } from '@chakra-ui/react';
import { CustomButton } from '@Modules/core/components';
import { createColumnHelper } from '@tanstack/react-table';

export type TValidTransactionInquiryDataTableData = {
  primaryKey: string | number,
  date: string,
  tc: string,
  referenceNumber: string | number,
  cardNumber: string,
  amount: string | number,
  mon: string,
  source: string,
  [x: string]: any,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

const columnHelper = createColumnHelper<TValidTransactionInquiryDataTableData>();

export function getValidTransactionInquiryDataTableColumns({
  isLoading,
  handleEdit,
}: Props) {
  return [
    columnHelper.accessor('date', {
      id: 'date',
      header: 'Date',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('tc', {
      id: 'tc',
      header: 'TC',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('referenceNumber', {
      id: 'referenceNumber',
      header: 'Numéro Référence',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('cardNumber', {
      id: 'cardNumber',
      header: 'Numéro Carte',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('amount', {
      id: 'amount',
      header: 'Montant',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('mon', {
      id: 'mon',
      header: 'Mon.',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('source', {
      id: 'source',
      header: 'Source',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{props.getValue()}</Center>
          </Skeleton>
        );
      },
    }),

    columnHelper.display({
      id: 'action',
      header: '',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <CustomButton
                size={'sm'}
                onClick={() => handleEdit(props.row)}
                mr={'1rem'}
              >
                Transaction
              </CustomButton>
            </Center>
          </Skeleton>
        );
      },
    }),
  ];
}
